// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1IQD7","amount":"Amount_amount__vfcpw","tip":"Amount_tip__1REYa","tipHeader":"Amount_tipHeader__3X9FR","tipsWrap":"Amount_tipsWrap__UY1E_"};